const it = {
  common: {
    action: "Azione",
    delete: "Cancella",
    edit: "Modifica",
    cancel: "Annulla",
    confirm: "Conferma",
    save: "Salva",
    yes: "Si",
    no: "No",
    search: "Cerca",
    reset: "Cancella",
    actionExecutedSuccessfully: "Azione eseguita correttamente",
    error: "Qualcosa è andato storto. Per favore riprova",
    requiredField: "Campo richiesto",
    cleanFilters: "Rimuovi filtri",
    refresh: "Aggiorna",
    create: "Crea",
    backToLogin: "Torna al login",
    next: "Avanti",
    back: "Indietro",
    upload: "Carica",
    close: "Chiudi",
    continue: "Continua",
    dndMessage:
      "Trascina qui i tuoi file da caricare, oppure clicca qui per selezionarli",
    deletePopUp: "Eliminare definitivamente?",
    add: "Aggiungi",
    signOut: "Esci",
    loading: "Caricamento in corso...",
  },
  components: {
    common: {
      programModal: {
        typeNew: "Nuovo programma",
        typeEdit: "Modifica programma",
      },
      programForm: {
        title: "Titolo",
        description: "Descrizione",
        url: "Url",
        posterUrl: "Immagine di copertina",
        trailer: "Trailer",
        trailerUrl: "Trailer (URL)",
        trailerInfo:
          "Seleziona una raccolta prima di associare un trailer al programma",
        categories: "Categorie",
        bannerId: "Banner pubblicitaro",
        adCircuitId: "Circuito pubblicitario",
        typology: "Tipologia",
        movie: "Film",
        tvShow: "Serie TV",
        numberOfSeason: "Numero stagioni",
        validFrom: "Valido da",
        validUntil: "Valido a",
        mustSee: "Da non perdere",
        tags: "Tags",
        isVipOnly: "Solo VIP",
        titlePlaceholder: "Inserisci il titolo",
        descriptionPlaceholder: "Inserisci la descrizione",
        urlPlaceholder: "Inserisci l'url",
        posterUrlPlaceholder: "Carica l'immagine di copertina",
        categoriesPlaceholder: "Seleziona le categorie",
        numberOfSeasonPlaceholder: "Selezionare una stagione",
        bannerIdPlaceholder: "Selezionare banner pubblicitario",
        adCircuitIdPlaceholder: "Selezionare circuito pubblicitario",
        validFromPlaceholder: "Inserisci la data di validazione iniziale",
        validUntilPlaceholder: "Inserisci la data di validazione finale",
        tagsPlaceholder: "Inserisci i tags",
        titleRequired: "Titolo richiesto",
        urlRequired: "Url richiesto",
        posterUrlRequired: "Immagine di copertina richiesta",
        categoriesRequired: "Seleziona almeno una categoria",
        numberOfSeasonRequired: "Numero di stagioni richiesto",
        validFromRequired: "Data validazione iniziale richiesta",
        validUntilRequired: "Data validazione finale richiesta",
      },
      advertisingCircuitModal: {
        typeNew: "Nuovo circuito pubblicitario",
        typeEdit: "Modifica circuito pubblicitario",
      },
      advertisingCircuitForm: {
        title: "Titolo",
        description: "Descrizione",
        createdAt: "Data creazione",
        updateAt: "Data modifca",
        titlePlaceholder: "Inserisci il titolo",
        descriptionPlaceholder: "Inserisci la descrizione",
        createdAtPlaceholder: "Inserisci la data",
        updateAtPlaceholder: "Inserisci la data",
        titleRequired: "Titolo richiesto",
        createdAtRequired: "Data richiesta",
        updateAtRequired: "Data richiesta",
      },
      menuLinkModal: {
        typeNew: "Nuovo link menù",
        typeEdit: "Modifica link menù",
      },
      menuLinkForm: {
        icon: "Icona",
        name: "Nome",
        onClickUrl: "Link associato",
        category: "Categoria programma",
        multimediaCategory: "Categoria episodio",
        program: "Programma",
        episode: "Episodio",
        namePlaceholder: "Inserisci il nome",
        onClickUrlPlaceholder: "Inserisci l'url",
        categoryPlaceholder: "Seleziona la categoria",
        iconRequired: "Icona richiesta",
        nameRequired: "Nome richiesto",
        langRequired: "Lingua richiesta",
        onClickUrlCategoryRequired: "Link o categoria richiesto",
      },
      footerModal: {
        typeNew: "Nuova riga del footer",
        typeEdit: "Modifica riga del footer",
      },
      footerForm: {
        html: "Html",
        orderNumber: "Ordine di visualizzazione",
        htmlPlaceholder: "Inserisci il codice html",
        htmlRequired: "Codice html richiesto",
        orderNumberRequired: "Ordine di visualizzazione richiesto",
      },
      streamingForm: {
        state: "Stato",
        active: "Attivo",
        notActive: "Non attivo",
        url: "Url",
        urlPlaceholder: "Inserisci l'url",
        coverUrl: "Immagine di copertina",
        coverUrlPlaceholder: "Carica l'immagine di copertina",
        urlRequired: "Url richiesto",
        coverUrlRequired: "Immagine di copertina richiesta",
      },
      firestickConfigForm: {
        category: "Titolo",
        logoImg: "Logo",
        streamingImg: "Immagine copertina streaming",
        description: "Descrizione",
        categoryRequired: "Titolo richiesto",
        categoryPlaceholder: "Inserisci il titolo",
        logoImgRequired: "Logo richiesto",
        logoImgPlaceholder: "Url logo",
        streamingImgRequired: "Immagine copertina streaming richiesta",
        streamingImgPlaceholder: "Carica l'immagine di copertina",
        descriptionRequired: "Descrizione richiesta",
        descriptionPlaceholder: "Inserisci la descrizione",
      },
    },
    SigninForm: {
      title: "Accedi",
      description: "Benvenuto! Per favore accedi per contnuare.",
      email: "Email",
      password: "Password",
      emailPlaceholder: "Inserisci la tua email",
      emailRequired: "Email è richiesta",
      emailInvalid: "Email non valida",
      passwordPlaceholder: "Inserisci la tua passsword",
      forgotPassword: "Password dimenticata?",
      passwordRequired: "La password è richiesta",
      passwordInvalid: "La password deve avere almeno 8 caratteri",
    },
    ForgotPasswordForm: {
      title: "Cambia la tua password",
      description:
        "Enter your username or email address and we will send you a link to reset your password.",
      password: "Cambia password",
      passwordPlaceholder: "Difgita la tua password",
    },
    changePasswordForm: {
      title: "Cambia la password",
      description: "Welcome back! Please signin to continue.",
      newPassword: "Nuova password",
      passwordPlaceholder: "Type your Password",
      confirmPassword: "Conferma password",
      button: "Cambia password",
    },
    categoryModal: {
      typeNew: "Nuova categoria",
      typeEdit: "Modifica categoria",
    },
    categoryForm: {
      name: "Nome",
      orderNumber: "Ordine di visualizzazione",
      state: "Stato",
      visibleInApp: "Visibile",
      notVisibleInApp: "Non visibile",
      namePlaceholder: "Inserisci un nome",
      nameRequired: "Nome richiesto",
      langRequired: "Lingua richiesta",
      visibleInAppRequired: "Scelta obbligatoria",
      orderPlaceholder: "Inserisci l'ordine di visualizzazione",
      orderNumberRequired: "Ordine di visualizzazione richiesto",
      programsOrder: "Ordine di visualizzazione programmi",
      multimediaOrder: "Ordine di visualizzazione episodi",
      olderProgramsFirst: "Mostra prima i programmi più vecchi",
      newestProgramsFirst: "Mostra prima i programmi più nuovi",
      olderMultimediaFirst: "Mostra prima gli episodi più vecchi",
      newestMultimediaFirst: "Mostra prima gli episodi più nuovi",
    },
    articleForm: {
      title: "Titolo",
      description: "Descrizione",
      image: "Immagine",
      category: "Categoria",
      categoryPlaceholder: "Inserisci la categoria",
      titlePlaceholder: "Inserisci il titolo",
      descriptionPlaceholder: "Inserisci la descrizione",
      titleRequired: "Titolo richiesto",
      descriptionRequired: "Descrizione rischiesta",
      imageRequired: "Immagine richiesta",
    },
    screenProgramDetail: {
      videoModal: {
        typeNew: "Nuovo video",
        typeEdit: "Modifica video",
      },
      videoForm: {
        title: "Titolo",
        description: "Descrizione",
        videoFolder: "Raccolta video",
        url: "Video",
        posterUrl: "Link immagine di copertina",
        inAppUrl: "Url in app",
        highlighted: "In evidenza",
        isHighlighted: "In evidenza",
        isNotHighlighted: "Non in evidenza",
        season: "Stagione",
        episodeNumber: "Numero episodio",
        duration: "Durata",
        validFrom: "Valido da",
        validUntil: "Valido a",
        coverImage: "Immagine di copertina",
        titlePlaceholder: "Inserisci un titolo",
        descriptionPlaceholder: "Inserisci una descrizione",
        urlPlaceholder: "Inserisci il video",
        posterUrlPlaceholder: "Inserisci il link dell'immagine di copertina",
        inAppUrlPlaceholder: "Inserisci l'url",
        highlightedPlaceholder: "Scegli un opzione",
        seasonPlaceholder: "Inserisci la stagione",
        episodeNumberPlaceholder: "Inserisci il numero episodio",
        durationPlaceholder: "Inserire la durata",
        validFromPlaceholder: "Inserisci la data di validazione iniziale",
        validUntilPlaceholder: "Inserisci la data di validazione finale",
        titleRequired: "Titolo richiesto",
        urlRequired: "Video richiesto",
        posterUrlRequired: "Immagine di copertina richiesta",
        inAppUrlRequired: "Url in app richiesto",
        highlightedRequired: "Selezione richiesta",
        seasonRequired: "Stagione richiesta",
        episodeNumberRequired: "Numero episodio richiesta",
        durationRequired: "Durata richiesta",
        validFromRequired: "Start validation date required",
        validUntilRequired: "End validation date required",
        mediaType: "Tipologia video",
        mediaUrl: "Link del video",
      },
    },
    screenAdvertisingDetail: {
      adModal: {
        typeNew: "Nuova pubblicità",
        typeEdit: "Modifica pubblicità",
      },
      adForm: {
        title: "Titolo",
        description: "Descrizione",
        url: "Video",
        posterUrl: "Link immagine di copertina",
        onClickUrl: "Link di condivisione",
        duration: "Durata",
        validFrom: "Valido da",
        validUntil: "Valido a",
        canBeSkipped: "Può essere saltato",
        isCanBeSkipped: "Saltabile",
        isNotCanBeSkipped: "Non saltabile",
        titlePlaceholder: "Inserisci un titolo",
        descriptionPlaceholder: "Inserisci una descrizione",
        urlPlaceholder: "Seleziona il video",
        posterUrlPlaceholder: "Inserisci l'immagine di copertina",
        onClickUrlPlaceholder: "Inserisci il link di condivisione",
        durationPlaceholder: "Inserire durata",
        validFromPlaceholder: "Inserisci la data di validazione iniziale",
        validUntilPlaceholder: "Inserisci la data di validazione finale",
        canBeSkippedPlaceholder: "Selezione obbligatoria",
        titleRequired: "Titolo richiesto",
        urlRequired: "Video richiesto",
        posterUrlRequired: "Immagine di copertina richiesta",
        onClickUrlRequired: "Link di condivisione richiesto",
        durationRequired: "Durata richiesta",
        validFromRequired: "Data validazione iniziale richiesta",
        validUntilRequired: "Data validazione finale richiesta",
        canBeSkippedRequired: "Selezione richiesta",
      },
    },
    screenUser: {
      userForm: {
        nominative: "Nominativo",
        nominativePlaceholder: "Inserisci il nominativo",
        email: "Email",
        emailPlaceholder: "Inserisci la mail",
        password: "Password",
        passwordPlaceholder: "Inserisci la password",
        userValidations: {
          nominativeRequired: "Nominativo richiesto",
          emailRequired: "Email richiesta",
        },
      },
    },
    screenBanners: {
      bannerModal: {
        typeNew: "Nuovo banner",
        typeEdit: "Modifca banner",
      },
      bannerForm: {
        title: "Titolo",
        description: "Descrizione",
        imageUrl: "Link immagine banner",
        onClickUrl: "Link di condivisione",
        createdAt: "Data creazione",
        validFrom: "Valido da",
        validUntil: "Valido a",
        titlePlaceholder: "Inserisci il titolo",
        descriptionPlaceholder: "Inserisci la descrizione",
        imageUrlPlaceholder: "Inserisci l'immagine",
        onClickUrlPlaceholder: "Inserisci il link di condivisione",
        createdAtPlaceholder: "Inserisci la data di creazione",
        validFromPlaceholder: "Inserisci la data di validazione iniziale",
        validUntilPlaceholder: "Inserisci la data di validazione finale",
        titleRequired: "Titolo richiesto",
        imageUrlRequired: "Link immagine richiesto",
        onClickUrlRequired: "Link di condivisione richiesto",
        createdAtRequired: "Data creazione richiesta",
        validFromRequired: "Data validazione iniziale richiesta",
        validUntilRequired: "Data validazione finale richiesta",
      },
    },
    screenMediaList: {
      uploadMediaModal: {
        title: "Carica video",
      },
    },
    screenPushNotifications: {
      pushNotificationsModal: {
        new: "Nuova notifica push",
      },
      pushNotificationsForm: {
        title: "Titolo",
        titlePlaceholder: "Inserisci il titolo",
        titleRequired: "Titolo richiesto",
        titleMaxLength: "Lunghezza massima titolo: 50",
        message: "Messaggio",
        messagePlaceholder: "Inserisci il messaggio",
        messageRequired: "Messaggio richiesto",
        messageMaxLength: "Lunghezza massima messaggio: 150",
      },
    },
  },
  screens: {
    programCategories: {
      pageHeader: {
        title: "Categorie programmi",
        buttonText: "Nuova categoria programma",
      },
      breadcrumb: {
        home: "Home",
        programCategories: "Categorie programmi",
      },
      column: {
        name: "Nome",
        order: "Ordine di visualizzazione",
        visible: "Visibilità",
        visibleActive: "Visibile",
        visibleNotActive: "Non visibile",
      },
      emptyData: "Nessuna categoria presente nel sistema",
    },
    multimediaCategories: {
      pageHeader: {
        title: "Categorie Episodi",
        buttonText: "Nuova categoria episodio",
      },
      breadcrumb: {
        home: "Home",
        multimediaCategories: "Categorie episodi",
      },
      column: {
        name: "Nome",
        order: "Ordine di visualizzazione",
        visible: "Visibilità",
        visibleActive: "Visibile",
        visibleNotActive: "Non visibile",
      },
      emptyData: "Nessuna categoria presente nel sistema",
    },
    articles: {
      title: "Titolo",
      author: "Autore",
      data: "Data",
      options: "Opzioni",
      pageHeader: {
        title: "Articoli",
        buttonText: "Nuovo",
      },
    },
    article: {
      pageHeader: {
        titleNew: "Nuovo articolo",
        titleEdit: "Modifica articolo",
      },
    },
    program: {
      pageHeader: {
        title: "Lista programmi",
        buttonText: "Nuovo programma",
      },
      column: {
        title: "Titolo",
        validFrom: "Inizio validazione",
        validUntil: "Fine validazione",
        firstDeletePopUp: "Spostare il programma nel cestino?",
        restore: "Ripristina",
      },
      breadcrumb: {
        home: "Home",
        programs: "Programmi",
      },
      emptyData: "Nessun programma presente nel sistema",
    },
    programDetail: {
      newEpisode: "Aggiungi episodio",
      newMovie: "Aggiungi film",
      pageHeader: {
        title: "Lista video",
        buttonText: "Modifica programma",
      },
      form: {
        seasonNumberPlaceholder: "Inserisci numero",
        seasonNumberRequired: "Number is required",
        addTab: "Aggiungi",
      },
      column: {
        title: "Titolo",
        url: "Url",
        videoNumber: "Numero episodio",
        validFrom: "Inizio validazione",
        validUntil: "Fine validazione",
      },
      breadcrumb: {
        home: "Home",
        programs: "Programmi",
      },
      season: "Stagione",
      adCircuit: "Circuito pubblicitario:",
      banner: "Banner pubblicitario:",
      emptyData: "Nessun episodio presente in questa stagione",
      emptyDataMovie: "Nessun film presente in questo programma",
      deleteSeason:
        "Attenzione, stai per eliminare la stagione {{seasonNumber}} e tutti i suoi episodi. Sei sicuro di voler procedere?",
    },
    users: {
      nominative: "Nominativo",
      email: "Email",
      options: "Opzioni",
      pageHeader: {
        title: "Utenti",
        buttonText: "Nuovo",
      },
    },
    user: {
      pageHeader: {
        titleNew: "Nuovo utente",
        titleEdit: "Modifica utente",
      },
    },
    banners: {
      pageHeader: {
        title: "Lista banner pubblicitari",
        buttonText: "Nuovo banner",
      },
      column: {
        title: "Titolo",
        validFrom: "Inizio validazione",
        validUntil: "Fine validazione",
      },
      breadcrumb: {
        home: "Home",
        banners: "Banner pubblicitario",
      },
      emptyData: "Nessun banner pubblicitario presente nel sistema",
    },
    advertisingCircuit: {
      pageHeader: {
        title: "Lista circuiti pubblicitari",
        buttonText: "Nuovo circuito pubblicitario",
      },
      column: {
        title: "Titolo",
      },
      breadcrumb: {
        home: "Home",
        advCircuit: "Circuiti pubblicitari",
      },
      emptyData: "Nessun circuito pubblicitario presente nel sistema",
    },
    advertisingDetail: {
      newAd: "Aggiungi pubblicità",
      pageHeader: {
        title: "Lista video",
        buttonText: "Modifica circuito pubblicitario",
      },
      form: {
        seasonNumberPlaceholder: "Inserisci numero stagioni",
        seasonNumberRequired: "Numero stagioni richiesto",
        addTab: "Aggiungi",
      },
      column: {
        title: "Titolo",
        url: "Video",
        validFrom: "Valido da",
        validUntil: "Valido a",
      },
      breadcrumb: {
        home: "Home",
        adCircuit: "Circuiti pubblicitari",
      },
      season: "Stagione",
      emptyData: "Nessuna pubblicità presente nel sistema",
    },
    mediaList: {
      breadcrumb: {
        home: "Home",
        media: "Media",
      },
      pageHeader: {
        title: "Media",
        buttonText: "Carica",
      },
      column: {
        title: "Titolo",
      },
      emptyData: "Nessun media",
    },
    iconsList: {
      breadcrumb: {
        home: "Home",
        icons: "Icone",
      },
      pageHeader: {
        title: "Icone",
        buttonText: "Carica",
      },
      column: {
        title: "Icona",
      },
      emptyData: "Nessuna icona",
    },
    menuLink: {
      pageHeader: {
        title: "Lista link menù",
        buttonText: "Nuovo link",
      },
      column: {
        icon: "Icona",
        name: "Nome",
        onClickUrl: "Link associato",
        category: "Categoria",
      },
      breadcrumb: {
        home: "Home",
        menuLinks: "Link menù",
      },
      emptyData: "Nessun link menù presente nel sistema",
    },
    footer: {
      pageHeader: {
        title: "Righe del footer",
        buttonText: "Nuova riga nel footer",
      },
      column: {
        orderNumber: "Ordine di visualizzazione",
        html: "html",
      },
      breadcrumb: {
        home: "Home",
        footer: "Righe del footer",
      },
      emptyData: "Nessuna riga del footer presente nel sistema",
    },
    streaming: {
      pageHeader: {
        title: "Configurazione streaming",
        buttonText: "Nuovo",
      },
      breadcrumb: {
        home: "Home",
        streaming: "Confiigurazione streaming",
      },
    },
    firestickConfig: {
      pageHeader: {
        title: "Configurazione firestick app",
        buttonText: "Nuovo",
      },
      breadcrumb: {
        home: "Home",
        firestickConfig: "Confiigurazione firestick app",
      },
    },
    pushNotifications: {
      pageHeader: {
        title: "Notifiche push",
        buttonText: "Nuova notifica",
      },
      breadcrumb: {
        home: "Home",
        pushNotifications: "Notifiche push",
      },
      column: {
        id: "id",
        title: "Titolo",
        message: "Messaggio",
        createdAt: "Data creazione",
      },
      emptyData: "Nessuna notifica push presente nel sistema",
    },
  },
  // If necessary
  messages: {
    formValidations: {
      form1: {
        key: "message",
      },
    },
    ui: {
      key: "message",
      vimeoMediaListError: "Errore di Vimeo. Elenco episodi non scaricato",
      vimeoMediaFoldersError: "Errore di Vimeo. Raccolta video non scaricata",
      vimeoUserError: "Errore di Vimeo. Dati utente non scaricati",
    },
  },
};

export default it;
